<template>
    <div class="max-w-screen-2xl mx-auto py-2 sm:px-2 lg:px-2">
        <div class="flex justify-center h-24">
            <div class="absolute left-44 top-">
                <img
                    src="/images/logo.png"
                    alt="logo"
                    class="fluid w-40"
                >
            </div>
            <div class="text-4xl my-auto">Entrevista de desligamento</div>
        </div>
        <div class="grid grid-cols-1">
            <div class="col-span-1">FIlial/Matrícula: {{ entrevista.funcionario_id | VMask("####/#####") }}</div>
            <div class="col-span-1">Nome: {{ entrevista.nome }}</div>
            <div class="col-span-1">Função: {{ entrevista.funcao_nome }}</div>
        </div>
        <div class="my-8">

            <div class="flex flex-col my-8">
                <div class="p-4 bg-red-700 text-white my-4 text-xl font-semibold">
                    Qual seguimento étnico e racial com que você se identifica
                </div>
                <div class="flex flex-column items-center gap-4 h-12">
                    <el-radio-group v-model="form.seguimento_etnico">
                        <el-radio
                            v-for="seguimento in seguimentosEtnicos"
                            :key="seguimento"
                            :label="seguimento"
                        >{{ seguimento }}
                        </el-radio>
                    </el-radio-group>
                    <div>
                        <el-input
                            v-show="form.seguimento_etnico == 'outro'"
                            class="w-100"
                            :maxlength="50"
                            placeholder="Seguimento étnico"
                            v-model="form.seguimento_etnico_outro"
                        ></el-input>
                    </div>
                </div>
                <jet-input-error
                    :message="form.errors.seguimento_etnico"
                    class="mt-2"
                />
            </div>

            <div
                v-if="entrevista.demissao_solicitada_por ==='FUNCIONARIO'"
                class="col-span-12 my-8"
            >
                <div class="p-4 bg-red-700 text-white text-xl font-semibold"> Motivos de desligamento</div>

                <CheckGroup
                    :hide-select-all="true"
                    :hide-open-close="true"
                    id-value="id"
                    label-value="nome"
                    :is-initial-open="true"
                    :items="motivos"
                    :initial-selecteds="[]"
                    v-model="form.motivos"
                    class-col-item="md:grid-cols-2 grid-cols-1"
                ></CheckGroup>
                <jet-input-error
                    :message="form.errors.motivos ? 'Selecione uma opção' : null"
                    class="mt-2"
                />
            </div>


            <div
                v-for="secao in questionario.secoes"
                :key="secao.id"
                class="flex flex-col my-8"
            >
                <div class="p-4 bg-red-700 text-white my-4 text-xl font-semibold">{{ secao.nome }}</div>
                <div class="space-y-8 p-4">
                    <div
                        v-for="pergunta in secao.perguntas"
                        :key="pergunta.id"
                        class="grid grid-cols-5"
                    >
                        <div class="col-span-3">
                            {{ pergunta.enunciado }}
                        </div>
                        <div class="col-span-2 flex flex-row">
                            <div>
                                <el-radio-group v-model="respostas[`pergunta_${pergunta.id}_resposta`]">
                                    <el-radio
                                        v-for="resposta in pergunta.tipo_respostas"
                                        :key="resposta.id"
                                        :label="resposta.valor"
                                    >{{ resposta.label }}
                                    </el-radio>
                                </el-radio-group>
                            </div>
                            <div class="ml-4">
                                <jet-input-error
                                    :message="form.errors[`pergunta_${pergunta.id}_resposta`] ? 'Selecione um opção' : null"/>
                            </div>

                        </div>
                        <div
                            v-if="deveJustificar(pergunta.resposta_para_justificar , respostas[`pergunta_${pergunta.id}_resposta`])"
                            class="col-span-5"
                        >
                            {{ pergunta.justificativa_label }} :
                            <el-input
                                class="w-100"
                                :placeholder="pergunta.justificativa_label"
                                v-model="respostas[`pergunta_${pergunta.id}_justificativa`]"
                            ></el-input>
                            <div class="ml-4">
                                <jet-input-error
                                    :message="form.errors[`pergunta_${pergunta.id}_justificativa`] ? 'Justifique sua resposta' : null"/>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="flex flex-row-reverse space-x-4 space-x-reverse px-4  py-4 sm:py-6 bg-gray-100">

            <button
                @click="save"
                class="bg-blue-500 hover:bg-blue-700 text-white text-center py-2 px-4 rounded"
            >
                Finalizar
            </button>
        </div>
    </div>

</template>

<script>
import CheckGroup from '@/Components/CheckGroup.vue';
import JetInputError from '@/Jetstream/InputError';
import Button from '../../Jetstream/Button.vue';

export default {
    name: 'Questionario',
    props: {
        entrevista: Object,
        questionario: Object,
        motivos: Array,
        seguimentosEtnicos: Array,
    },
    components: {CheckGroup, JetInputError,},
    data() {
        return {
            form: this.$inertia.form({
                'entrevista_id': this.entrevista.id,
                'motivos': [],
                seguimento_etnico: null,
                seguimento_etnico_outro: null,
            }),
            respostas: {}
        }
    },
    methods: {
        deveJustificar(perguntaValidador, resposta) {
            return perguntaValidador && perguntaValidador.includes(resposta);
        },
        save() {
            this.form.transform((data) => ({
                ...data,
                ...this.respostas,
            })).post(route('entrevista-colaborador.questionario.store'));
        }
    }

}
</script>

<style>
</style>
